module.exports = __webpack_public_path__ + "static/media/ireland.e276c362.webp";